<div class="mission-container" *ngIf="currentMission">
  <ng-container *ngIf="!showMissionResult; else missionResultTpl">
    <h3>Nhiệm vụ sức khỏe</h3>

    <ng-container *ngIf="currentMission; else noMissionTpl">
      <div class="mission-question">
        <p>{{ currentMission.question }}</p>
        <div class="mission-coins text-end">
          <span>+ {{ currentMission.CollectedCoin || 1 }} 🏵️</span>
        </div>
      </div>

      <div class="mission-buttons">
        <button (click)="checkAnswer(false)" class="btn-false">Sai</button>
        <button (click)="checkAnswer(true)" class="btn-true">Đúng</button>
      </div>
    </ng-container>
  </ng-container>

  <!-- Kết quả nhiệm vụ -->
  <ng-template #missionResultTpl>
    <div class="mission-result">
      <div *ngIf="missionResultCorrect; else incorrectTpl" class="result-correct">
        <h3>Chính xác!</h3>
        <p>Bạn đã nhận được {{ currentMission?.CollectedCoin || 1 }} 🏵️.</p>
      </div>
    </div>
  </ng-template>

  <!-- Trường hợp sai -->
  <ng-template #incorrectTpl>
    <div class="result-incorrect">
      <h3>Chưa chính xác!</h3>
      <p>Hãy thử lại với câu hỏi tiếp theo.</p>
    </div>
  </ng-template>

  <!-- Không có nhiệm vụ -->
  <ng-template #noMissionTpl>
    <p>Không có nhiệm vụ nào.</p>
  </ng-template>
</div>
